import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePromotions } from '../hooks/useFirestoreData';
import './EventsPage.css';

function PromotionsPage() {
    const [error, setError] = useState(null);
    const { promotions, loadingPromotions } = usePromotions(setError);

    if (loadingPromotions) {
        return <p>Cargando eventos...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div className="events-page">
            <h1>Eventos</h1>
            <div className="events-list">
                {promotions.map(promo => (
                    <Link to={`/eventos/${promo.id}`} key={promo.id} className="event-card">
                        <img src={promo.graphicPieceUrl} alt={promo.title} className="event-image" />
                        <div className="event-content">
                            <h2>{promo.title}</h2>
                            <p>{promo.description}</p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default PromotionsPage;
